import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }, hideCustomFilterComponent = []) {
        const route = Laroute.route(
            'franchise.report.tng.subsidy.reimbursement.search.meta',
        );

        startLoading(dispatch, 'get-meta');

        return axios
            .get(route)
            .then(res => {
                if (hideCustomFilterComponent.length) {
                    hideCustomFilterComponent.map(displayName => {
                        let index = res.data.filters.findIndex(
                            d => d.display_name === displayName,
                        );

                        if (index >= 0) {
                            res.data.filters.splice(index, 1);
                        }
                    });
                }

                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary(
        { state, dispatch },
        hideCustomFilterComponent = [],
    ) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta', hideCustomFilterComponent);
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
